// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"primaryButton_primaryButton__1r3cG"};